<template>
  <app-view :title="app" :backable="false" :footerShow="true">
    <main class="bg-white pb-14 desk:pb-0">
      <section>
        <div v-if="banners && banners.length" class="border-b border-gray-100 desk:px-6 desk:pt-5">
          <BannerCarousel :banners="banners" />
        </div>

        <div class="px-4 py-3 desk:px-6 desk:py-4">
          <nuxt-link
            :to="localePath('/order')"
            aria-label="搜尋商品"
            class="flex w-full items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-left active:bg-gray-100 desk:min-h-[44px] desk:hover:bg-gray-100"
          >
            <SearchIcon class="h-4 w-4 flex-none text-gray-400" />
            <span class="truncate text-xs text-gray-500 desk:text-sm">搜尋遊戲、點數卡、禮包或商品</span>
          </nuxt-link>
        </div>
      </section>

      <section class="border-t border-gray-100 py-4 desk:py-3">
        <div v-if="catalogs.length" class="grid grid-cols-4 gap-y-4 px-3 desk:flex desk:flex-wrap desk:gap-6 desk:px-6">
          <nuxt-link
            v-for="item in catalogs"
            :key="item.name"
            class="flex flex-col items-center justify-start rounded-lg py-1 active:opacity-70 desk:flex-row desk:items-center desk:gap-3 desk:pr-4 desk:hover:bg-gray-50"
            :to="switched(item)"
            :aria-label="item.name"
          >
            <span
              class="flex h-11 w-11 items-center justify-center rounded-lg bg-gray-50"
            >
              <img
                :src="cdnImage(item.image || '/imgs/no_photo.jpg', 120)"
                :alt="item.name"
                class="h-full w-full object-contain mix-blend-multiply"
                v-lazy-load
                loading="lazy"
                @error="applyImageFallback($event, item.image)"
              />
            </span>
            <span
              class="mt-2 max-w-full truncate px-1 text-[11px] font-medium leading-tight text-gray-700 desk:mt-0 desk:text-sm"
            >
              {{ item.name }}
            </span>
          </nuxt-link>
        </div>
        <p v-else class="px-4 py-6 text-center text-sm text-gray-400">暫無分類</p>
      </section>

      <section
        class="border-t border-gray-100 px-4 py-3 text-center text-[11px] leading-tight text-gray-400 desk:px-6"
      >
        線上落單 · 多種付款 · 客服跟進
      </section>

      <section
        data-desktop-home-promotions
        class="space-y-6 border-t border-gray-100 px-3 pt-4 pb-12 desk:space-y-10 desk:px-6 desk:pt-4"
      >
        <PromotionVue
          v-for="catalog in mycatalogs()"
          :key="catalog.no"
          :catalog="catalog"
        />
      </section>
    </main>
  </app-view>
</template>

<script>
import { mapGetters } from "vuex";
import BannerCarousel from "@/components/index/BannerCarousel.vue";
import PromotionVue from "@/components/product/Promotion.vue";
import { SearchIcon } from "@vue-hero-icons/outline";
import { applyImageFallback } from "@/utils/desktopImages";

export default {
  components: {
    BannerCarousel,
    PromotionVue,
    SearchIcon,
  },
  head() {
    const info = this.$store.getters["app/info"];
    const stripBlockedTerms = (value) =>
      String(value || "").replace(/[\u865a\u865b][\u64ec\u62df]/g, "");
    const appName = stripBlockedTerms(info.name);
    const cleanDescription =
      stripBlockedTerms(info.description)
        .replace(/(<([^>]+)>)/gi, "")
        .substring(0, 150) + "...";
    const keywords =
      info.keywords && info.keywords !== "undefined"
        ? stripBlockedTerms(info.keywords)
        : "遊戲點數, 達人商城, 遊戲充值";
    const pageTitle = `${appName} | 澳門最齊全遊戲點數卡、遊戲商品充值平台`;

    return {
      title: pageTitle,
      link: [
        {
          rel: "canonical",
          href: `${process.env.APP_URL}`,
        },
      ],
      meta: [
        {
          hid: "robots",
          name: "robots",
          content: "index, follow",
        },
        {
          hid: "keywords",
          name: "keywords",
          content: keywords,
        },
        {
          hid: "description",
          name: "description",
          content: cleanDescription,
        },
        {
          hid: "og:type",
          name: "og:type",
          property: "og:type",
          content: "website",
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: pageTitle,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: appName,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: `${process.env.APP_URL}`,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: cleanDescription,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: `${process.env.APP_URL}/static/icon.png`,
        },
        {
          hid: "twitter:card",
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: pageTitle,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: cleanDescription,
        },
      ],
    };
  },

  auth: false,

  async asyncData({ store }) {
    return {
      app: store.getters["app/info"].name,
    };
  },

  methods: {
    applyImageFallback,
    switched(category) {
      return this.localePath({
        name: "order",
        query: { category: category.no, title: category.name },
      });
    },

    mycatalogs() {
      return this.catalogs.filter((item) => item.no != 0);
    },
  },

  computed: {
    ...mapGetters({
      info: "app/info",
      banners: "app/banners",
      catalogs: "app/catalogs",
    }),
  },
};
</script>
